import { ReflexContainer, ReflexSplitter, ReflexElement } from 'react-reflex';
import 'react-reflex/styles.css';
import { BsThreeDotsVertical, BsThreeDots } from 'react-icons/bs';

const ReflexHorizontalContainer = ({ Left, Right, ratio }) => {
  const size = {
    left: !!ratio ? ratio.left : 1,
    right: !!ratio ? ratio.right : 1,
  };
  return (
    <ReflexContainer
      orientation="vertical"
      style={{ height: '100%', width: '100%' }}
    >
      <ReflexElement className="pane-content" flex={size.left}>
        {Left}
      </ReflexElement>
      <ReflexSplitter
        propagate={true}
        style={{
          position: 'relative',
          background: '#edecec',
          width: '3px',
          border: 0,
        }}
      >
        <BsThreeDotsVertical
          style={{
            position: 'absolute',
            top: '50%',
            left: '-6.4px',
            color: '#a09f9f',
          }}
        />
      </ReflexSplitter>
      <ReflexElement className="pane-content" flex={size.right}>
        {Right}
      </ReflexElement>
    </ReflexContainer>
  );
};

export default ReflexHorizontalContainer;
